import { useUser } from "../useUser";

export const useLinkedAccounts = () => {
  const { allstarUser } = useUser();
  const hasRiotLinked = !!allstarUser?.user?.riot?.puuid;
  const hasSteamLinked = !!allstarUser?.user?.steam?.steamid;
  const hasFaceitLinked = !!allstarUser?.user?.faceit?.nickname;
  const hasEpicLinked = !!allstarUser?.user?.epic?.id;
  const hasBattlenetLinked = !!allstarUser?.user?.battlenet?.battletag;
  // Internal/admin accounts see the discount regardless of real FACEIT status,
  // so the team can QA the UI without needing a real FACEIT Premium account.
  // @allstar.gg matches the same internal-employee signal useShouldShowSubscriptionOverhaul uses.
  const isInternalUser =
    !!allstarUser?.isAdmin ||
    !!allstarUser?.decoded?.sub?.endsWith("@allstar.gg");
  const hasFaceitPremiumDiscount =
    isInternalUser ||
    (hasFaceitLinked &&
      !!allstarUser?.user?.faceitMembershipTiers?.includes("PREMIUM"));

  return {
    hasRiotLinked,
    hasSteamLinked,
    hasFaceitLinked,
    hasEpicLinked,
    hasBattlenetLinked,
    hasFaceitPremiumDiscount,
  };
};
